import { getNextSubscriptionStartDate } from '/source/js/helpers/subscription';
import { formatDate, getDate } from '/source/js/utils/dateUtil';

$(function() {
    let $subscriptionOrder = $('.subscription-order');
    if($subscriptionOrder.length === 0) { return; }
    let subscriptionOrderData = $subscriptionOrder.data('subscriptionsetup');
    if(!subscriptionOrderData) { return; }
    const $inputDatePickerElement = $('#subscription-order-datepicker');
    const startDate = getNextSubscriptionStartDate(subscriptionOrderData.StartDate, subscriptionOrderData.DateFormat);
    const endDate = getNextSubscriptionStartDate(subscriptionOrderData.EndDate, subscriptionOrderData.DateFormat);
    const formattedDateValue = formatDate(getDate($inputDatePickerElement.val(), subscriptionOrderData.DateFormat), subscriptionOrderData.DateFormat);
    $inputDatePickerElement.val(formattedDateValue);
    $inputDatePickerElement.datepicker({
        format: subscriptionOrderData.DateFormat, // format for date
        startDate: startDate, // start date starts the next day
        endDate: endDate, // end date end at 61 days
        autoclose: true
    });
});
